import { hideLoading, showLoading } from 'react-redux-loading-bar';
import bookmarkApi from '../../../utils/savedThreads';
import { showToast } from '../../slices/uiContextSlice';

const ActionType = {
  RECEIVE_BOOKMARKS: 'RECEIVE_BOOKMARKS',
  ADD_BOOKMARK: 'ADD_BOOKMARK',
  DELETE_BOOKMARK: 'DELETE_BOOKMARK',
};

const savedToast = {
  id: Math.random().toString(36).substring(2, 4) + Date.now().toString(36),
  type: 'success',
  description: 'Thread saved locally',
};

const deletedToast = {
  id: Math.random().toString(36).substring(2, 4) + Date.now().toString(36),
  type: 'warning',
  description: 'Thread removed from saved list',
};

function receiveBookmarksActionCreator(bookmarks) {
  return {
    type: ActionType.RECEIVE_BOOKMARKS,
    payload: { bookmarks },
  };
}

function addBookmarkActionCreator(bookmark) {
  return {
    type: ActionType.ADD_BOOKMARK,
    payload: { bookmark },
  };
}

function deleteBookmarkActionCreator(id) {
  return {
    type: ActionType.DELETE_BOOKMARK,
    payload: { id },
  };
}

function asyncReceiveBookmarks() {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const bookmarks = await bookmarkApi.getThreads();
      dispatch(receiveBookmarksActionCreator(bookmarks));
    } catch (error) {
      console.log('Failed to load saved threads');
    }
    dispatch(hideLoading());
  };
}

function asyncAddBookmark(thread) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const bookmark = await bookmarkApi.saveThread(thread);
      if (bookmark) dispatch(showToast(savedToast));
      dispatch(addBookmarkActionCreator(bookmark));
      const bookmarks = await bookmarkApi.getThreads();
      dispatch(receiveBookmarksActionCreator(bookmarks));
    } catch (error) {
      console.log('Failed to add thread to bookmarks');
    }
    dispatch(hideLoading());
  };
}

function asyncDeleteBookmark(id) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const response = await bookmarkApi.deleteThread(id);
      if (response) {
        dispatch(showToast(deletedToast));
        dispatch(deleteBookmarkActionCreator(id));
      }
      const bookmarks = await bookmarkApi.getThreads();
      dispatch(receiveBookmarksActionCreator(bookmarks));
    } catch (error) {
      console.log('Failed to delete bookmark');
    }
    dispatch(hideLoading());
  };
}

export {
  ActionType,
  receiveBookmarksActionCreator,
  addBookmarkActionCreator,
  deleteBookmarkActionCreator,
  asyncReceiveBookmarks,
  asyncAddBookmark,
  asyncDeleteBookmark,
};
